<template>
    <div>
        <form-contract-client-e-e :disabled="true"/>
        <form-contract-provider-e-e/>
        <form-specific-plan-prevention/>
        <form-transfer-certificate :disabled="true"/>
    </div>
</template>

<script>
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'

import formContractClientEE
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formContractClientEE"
import formTransferCertificate
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/formTransferCertificate"
import formContractProviderEE
    from "@/views/gei/children_installations/form/tabDocuments/components/formContractProviderEE"
import formSpecificPlanPrevention
    from "@/views/gei/children_installations/form/tabDocuments/components/formSpecificPlanPrevention"

const {mapFields} = createHelpers({
    getterType: 'masterInstallationDocuments/getField',
    mutationType: 'masterInstallationDocuments/updateField',
})

export default {
    name: "FormGeneralDataAndRisksView",
    components: {
        formContractClientEE,
        formTransferCertificate,
        formContractProviderEE,
        formSpecificPlanPrevention

    },
    data() {
        return {
            SpanishLocale,
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('masterInstallationDocuments', []),
        ...mapFields({

        }),
    },
    created() {

    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>